module.exports = __webpack_public_path__ + "img/profile_teo_au1.8c6aa13e.jpg";